var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lo footer"},[_c('mdSiteTools',{ref:"tools",on:{"sendEvent":_vm.receiveEvent}}),(_vm.showShopping)?_c('mdShoppingArea',{on:{"sendEvent":_vm.receiveEvent}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }